import axios from "axios";
import { getGlobalAPIUrl } from "../helpers/apiHelpers";

export const IsAuthenticated = async (): Promise<boolean> => {
  try {
    const response = await axios.get(getGlobalAPIUrl("authuser"));
    const { data } = response;

    if (data.userName) return true;
    console.log("No hay usuario logueado");
    return false;
  } catch (error) {
    console.log("err", error);
    return false;
  }
};

export const HasRole = async (roles: string | string[]): Promise<boolean> => {
  try {
    // Convertir el parámetro roles a array si es string
    const requiredRoles = Array.isArray(roles) ? roles : [roles];

    const response = await axios.get(getGlobalAPIUrl("authuser"));
    const { data } = response;

    for (const role of requiredRoles) {
      if (role.endsWith('*')) {
        const prefix = role.slice(0, -1);
        if (data.roles.some((userRole: string) => userRole.startsWith(prefix))) {
          return true; // Rol con prefijo encontrado
        }
      } else if (data.roles.includes(role)) {
        return true; // Rol exacto encontrado
      }
    }

    console.log("El usuario no tiene ninguno de los roles requeridos", requiredRoles);
    return false;

  } catch (error) {
    console.error("Error verificando roles:", error);
    return false;
  }
}
